import { privateAxios } from "../../../config/apiConfig";
import {
  GET_ALL_UI_COLOR_FONT_REQUEST, GET_ALL_UI_COLOR_FONT_SUCCESS, GET_ALL_UI_COLOR_FONT_FAILURE, CREATE_UI_COLOR_FONT_REQUEST, CREATE_UI_COLOR_FONT_FAILURE, UPDATE_UI_COLOR_FONT_REQUEST, UPDATE_UI_COLOR_FONT_FAILURE
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllUIColorFont = () => async (dispatch) => {
  dispatch({ type: GET_ALL_UI_COLOR_FONT_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/ui_color_fonts`);
    dispatch({ type: GET_ALL_UI_COLOR_FONT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_UI_COLOR_FONT_FAILURE, payload: error.message });
  }
};

export const createUIColorFont = (colorData) => async (dispatch) => {
  dispatch({ type: CREATE_UI_COLOR_FONT_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/ui_color_font`, colorData);
    if (data.status === "SUCCESS") {
      dispatch(getAllUIColorFont());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_UI_COLOR_FONT_FAILURE, payload: error.message });
  }
};

export const updateUIColorFont = (uiColorFontId, colorData) => async (dispatch) => {
  dispatch({ type: UPDATE_UI_COLOR_FONT_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/ui_color_font/${uiColorFontId}`,
      colorData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllUIColorFont());
      toast.success("UI Color Font Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_UI_COLOR_FONT_FAILURE, payload: error.message });
  }
};
